export var AuthScope;
(function (AuthScope) {
    AuthScope["AopAccessApi"] = "api://aop/access-api";
})(AuthScope || (AuthScope = {}));
